import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import { TextButton } from 'components/core/Button';

const BaseButton = ({ labelId, ...otherProps }) => (
  <TextButton
    label={labelId ? <LocalizedMessage id={labelId} /> : null}
    {...otherProps}
  />
);

BaseButton.propTypes = {
  labelId: PropTypes.string,
};

BaseButton.defaultProps = {
  labelId: null,
};

export const AccessesTextButton = (props) => <BaseButton iconId="btnAccesses" labelId="button.displayAccesses" {...props} />;
export const AddAccessRightTextButton = (props) => <BaseButton iconId="btnAddRight" labelId="button.addAccessRight" {...props} />;
export const AddEquipmentTextButton = (props) => <BaseButton iconId="btnAdd" labelId="button.addEquipment" {...props} />;
export const AddRightTextButton = (props) => <BaseButton iconId="btnAdd" labelId="button.addRight" {...props} />;
export const AddTextButton = (props) => <BaseButton iconId="btnAdd" labelId="button.add" {...props} />;
export const AntipassbackTextButton = (props) => <BaseButton iconId="btnAntipassback" labelId="button.antipassback" {...props} />;
export const BackTextButton = (props) => <BaseButton iconId="btnBack" labelId="button.back" {...props} />;
export const CancelTextButton = (props) => <BaseButton iconId="btnCancelOutline" labelId="button.delete" {...props} />;
export const CategorizeTextButton = (props) => <BaseButton iconId="btnCategorize" labelId="button.categorize" {...props} />;
export const ConfigurationTextButton = (props) => <BaseButton iconId="btnConfiguration" labelId="button.configure" {...props} />;
export const ConfigureTextButton = (props) => <BaseButton iconId="btnSettings" labelId="button.configure" {...props} />;
export const CreateTextButton = (props) => <BaseButton iconId="btnAdd" labelId="button.createNew" {...props} />;
export const CreditCardTextButton = (props) => <BaseButton iconId="btnCreditCard" labelId="button.creditCard" {...props} />;
export const CustomersTextButton = (props) => <BaseButton iconId="btnUsers" labelId="button.customers" {...props} />;
export const DailyCodesTextButton = (props) => <BaseButton iconId="btnDailyCodes" labelId="button.dailyCodes" {...props} />;
export const DeleteTextButton = (props) => <BaseButton iconId="btnDelete" labelId="button.delete" {...props} />;
export const DevicesTextButton = (props) => <BaseButton iconId="btnDevice" labelId="button.devices" {...props} />;
export const DisplayListTextButton = (props) => <BaseButton iconId="btnDisplayList" labelId="button.displayList" {...props} />;
export const DownloadInvoiceTextButton = (props) => <BaseButton iconId="btnDownload" labelId="button.downloadInvoice" {...props} />;
export const DuplicateTextButton = (props) => <BaseButton iconId="btnDuplicate" labelId="button.duplicate" {...props} />;
export const EditTextButton = (props) => <BaseButton iconId="btnEdit" labelId="button.edit" {...props} />;
export const EmailTextButton = (props) => <BaseButton iconId="btnEmail" labelId="button.email" {...props} />;
export const EmptyWeekendTextButton = (props) => <BaseButton iconId="btnEmptyCalendar" labelId="button.emptyWeekend" {...props} />;
export const EquipmentTextButton = (props) => <BaseButton iconId="btnEquipment" labelId="button.equipment" {...props} />;
export const ExportTextButton = (props) => <BaseButton iconId="btnExport" labelId="button.export" {...props} />;
export const GlobalSettingsTextButton = (props) => <BaseButton iconId="btnPeriod" labelId="button.globalSettings" {...props} />;
export const GroupsTextButton = (props) => <BaseButton iconId="btnGroups" labelId="button.groups" {...props} />;
export const HistoryTextButton = (props) => <BaseButton iconId="btnHistory" labelId="button.history" {...props} />;
export const ImportTextButton = (props) => <BaseButton iconId="btnUpload" labelId="button.import" {...props} />;
export const LocateTextButton = (props) => <BaseButton iconId="btnMapMarker" labelId="button.locate" {...props} />;
export const MulticriteriaTextButton = (props) => <BaseButton iconId="btnFiltersMore" labelId="button.multicriteria" {...props} />;
export const OperationsHistoryTextButton = (props) => <BaseButton iconId="btnHistory" labelId="button.operationsHistory" {...props} />;
export const PlanningsTextButton = (props) => <BaseButton iconId="btnPlanning" labelId="button.plannings" {...props} />;
export const RefreshTextButton = (props) => <BaseButton iconId="btnRefresh" labelId="button.refresh" {...props} />;
export const ReplaceTextButton = (props) => <BaseButton iconId="btnReplace" labelId="button.replace" {...props} />;
export const ResetTextButton = (props) => <BaseButton iconId="btnReset" labelId="button.reset" {...props} />;
export const StopTextButton = (props) => <BaseButton iconId="btnStop" labelId="button.stop" {...props} />;
export const UpdateTextButton = (props) => <BaseButton iconId="btnEditAlt" labelId="button.update" {...props} />;
export const DeclareOutsideTextButton = (props) => <BaseButton iconId="btnDeclareOutside" labelId="button.declareOutside" {...props} />;
export const DeclareInsideTextButton = (props) => <BaseButton iconId="btnDeclareInside" labelId="button.declareInside" {...props} />;
export const ValidatePaymentTextButton = (props) => <BaseButton iconId="btnValidatePayment" labelId="button.validatePayment" {...props} />;
export const DownloadReportTextButton = (props) => <BaseButton iconId="btnDownload" variant="outlined" labelId="button.downloadReport" {...props} />;

// Shortcut button
export const ShortcutTextButton = ({ path, ...otherProps }) => (
  <BaseButton
    iconId="btnOpenInNew"
    labelId="button.display"
    labelPosition="before"
    path={{ path, targetBlank: true }}
    {...otherProps}
  />
);

ShortcutTextButton.propTypes = {
  path: PropTypes.string.isRequired,
};

// External link button
export const ExternalLinkTextButton = ({ href, ...otherProps }) => (
  <BaseButton
    iconId="btnOpenInNew"
    labelId="button.display"
    labelPosition="before"
    href={href}
    target="_blank"
    {...otherProps}
  />
);

ExternalLinkTextButton.propTypes = {
  href: PropTypes.string.isRequired,
};

// Link button
export const LinkTextButton = (props) => <BaseButton {...props} />;



// WEBPACK FOOTER //
// ./components/buttons/TextButtons.js